var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "134px",
    height: "142px",
    viewBox: "0 0 134 142",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "48D75792-5D12-4A5F-870E-31458749D92A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Search-\\uD83D\\uDD0E",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search---Free-Sugar-Baby",
    transform: "translate(-127.000000, -189.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upgrade/Locked-Premium-Sugar-Daddy",
    transform: "translate(89.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(42.240000, 34.320000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCCCCC",
    strokeWidth: 8,
    fillRule: "nonzero",
    x: 0,
    y: 51.48,
    width: 85.8,
    height: 79.2,
    rx: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.16,51.1433585 L17.1601855,21.1868627 C17.9841168,7.35882255 26.1623931,0.299410909 41.6950143,0.00862781313 C57.2276356,-0.282155283 65.8459466,6.77725636 67.5499473,21.1868627 L67.5499473,51.1433585",
    id: "Path-11",
    stroke: "#CCCCCC",
    strokeWidth: 8,
    strokeLinecap: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    cx: 42.9,
    cy: 83.82,
    r: 9.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    x: 38.28,
    y: 87.12,
    width: 9.24,
    height: 22.44,
    rx: 4
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy-2",
    fill: "#710D0D",
    fillRule: "nonzero",
    points: "137.94 160.652253 117.379272 171.519414 121.360942 148.606862 104.672043 132.410586 127.693579 129.117011 137.94 108.24 148.186421 129.117011 171.207957 132.410586 154.519058 148.606862 158.500728 171.519414"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumLock);
export default __webpack_public_path__ + "static/media/premium-lock.b3aef9d501531738c28e80a66aa6bae4.svg";
export { ForwardRef as ReactComponent };